import * as React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import RemoveLinkIcon from '@mui/icons-material/DeleteOutline';
import EditLinkIcon from '@mui/icons-material/Edit';

/**
 * value - the item id
 *
 * @param {} param0
 * @returns
 */
export const LinkProperty = ({ item, onRemove = () => {}, onEdit = _ => {} }) => {

    const user = useSelector(state => state.login.user);

    const handleRemoveLink = () => {
        onRemove?.();
    }

    const handleEditLink = () => {
        onEdit?.(item);
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px", padding: "4px" }}>
            <Typography>{item.name}</Typography>
            <IconButton onClick={handleEditLink} size='small'><EditLinkIcon /></IconButton>
            <IconButton onClick={handleRemoveLink} size='small'><RemoveLinkIcon /></IconButton>
        </Box>
    );
}